import {
  SET_SEARCH_FOWARD_CONTACT,
  SET_FOWARD_CONTACT,
  SET_FOREX,
  SET_FOWARD_CONTACT_SELECT_ID,
  ADD_FOREX_IN_FOWARD_CONTACT,
  EDIT_FOREX_IN_FOWARD_CONTACT,
  SET_FOREX_SELECT_ID,
  SET_FOREXS_DATA,
  UPDATE_FOREX_HISTORY,
  REMOVE_FOREX_HISTORY,
} from "./actionType";

const initState = {
  searchData: [],
  fowardContactSelectData: {
    Forexs: [],
  },
  fowardContactSelectId: undefined,
  forexSelectData: {},
  forexSelectId: undefined,
};

export default function reducer(state = initState, action) {
  return {
    searchData: searchData(state.searchData, action),
    fowardContactSelectData: fowardContactSelectData(
      state.fowardContactSelectData,
      action
    ),
    forexSelectData: forexSelectData(state.forexSelectData, action),
    fowardContactSelectId: fowardContactSelectId(
      state.fowardContactSelectId,
      action
    ),
    forexSelectId: forexSelectId(state.forexSelectId, action),
  };
}

function forexSelectId(state = undefined, action) {
  switch (action.type) {
    case SET_FOREX_SELECT_ID: {
      return action.payload;
    }
    default:
      return state;
  }
}

function fowardContactSelectId(state = undefined, action) {
  switch (action.type) {
    case SET_FOWARD_CONTACT_SELECT_ID: {
      return action.payload;
    }
    default:
      return state;
  }
}

function searchData(state = [], action) {
  switch (action.type) {
    case SET_SEARCH_FOWARD_CONTACT: {
      return [...action.payload];
    }
    default:
      return state;
  }
}

function fowardContactSelectData(state = {}, action) {
  switch (action.type) {
    case SET_FOWARD_CONTACT: {
      return {
        ...action.payload,
      };
    }
    case ADD_FOREX_IN_FOWARD_CONTACT: {
      return {
        ...state,
        Forexs: [
          ...state.Forexs,
          {
            ...action.payload,
          },
        ],
      };
    }
    case EDIT_FOREX_IN_FOWARD_CONTACT: {
      return {
        ...state,
        Forexs: [
          ...state.Forexs.slice(0, action.idx),
          {
            ...action.payload,
          },
          ...state.Forexs.slice(action.idx + 1),
        ],
      };
    }
    case SET_FOREXS_DATA: {
      return {
        ...state,
        Forexs: [...action.payload.map((m) => ({ ...m }))],
      };
    }
    default:
      return state;
  }
}

function forexSelectData(state = {}, action) {
  switch (action.type) {
    case SET_FOREX: {
      let newArr = action.payload.Historys
        ? action.payload.Historys.map((m) => ({ ...m }))
        : [];
      // let lastAmount = newArr.reduce((prev, cur) => {
      //     cur.Balance = prev
      //     return prev - cur.EstimateAmount
      // }, action.payload.Amount || 0)

      return {
        ...action.payload,
        Historys: [...newArr],
      };
    }
    case UPDATE_FOREX_HISTORY: {
      let newArr = state.Historys.map((m, idx) => {
        if (action.index === idx)
          return {
            ...action.payload,
          };
        return m;
      });

      let totalUsedAmount = 0;
      let totalBookedAmount = 0;

      newArr.forEach((cur) => {
        totalUsedAmount += cur.ActualAmount || 0;
        totalBookedAmount += cur.ActualAmount ? 0 : cur.EstimateAmount || 0;
      });

      return {
        ...state,
        Historys: [...newArr],
        SpendingAmount: totalUsedAmount,
        Balance: state.Amount - totalUsedAmount,
        BookedAmount: totalBookedAmount,
      };
    }
    case REMOVE_FOREX_HISTORY: {
      let newArr = [
        ...state.Historys.slice(0, action.index),
        state.Historys.slice(action.index + 1),
      ];

      let totalUsedAmount = 0;
      let totalBookedAmount = 0;
      // let lastAmount = newArr.reduce((prev, cur) => {
      //     cur.Balance = prev
      //     totalUsedAmount += cur.ActualAmount || 0
      //     totalBookedAmount += cur.EstimateAmount || 0
      //     return prev - cur.EstimateAmount
      // }, state.Amount || 0)
      return {
        ...state,
        Historys: newArr,
        SpendingAmount: totalUsedAmount,
        Balance: state.Amount - totalUsedAmount,
        BookedAmount: totalBookedAmount,
      };
    }
    default:
      return state;
  }
}
